import { Theme } from '@mui/material';
import { defaultHostColorHex } from '../../pages/host/host-page.styles';

export const eventCardStyles = (
	theme: Theme,
	primaryColor = defaultHostColorHex,
	backgroundColor = '#000000',
	hoverColor = '#BE4800',
	lightTextColor?: string | null,
	isOpeningEventPage = false
) => ({
	root: {
		display: 'flex',
		backgroundColor: `${backgroundColor}80`,
		position: 'relative',
		width: '100%',
		height: { xs: '318px', sm: '175px' },
		borderRadius: { xs: '4px', sm: '8px' },
		flexDirection: { xs: 'column', sm: 'row' },
		overflow: 'hidden',
		cursor: isOpeningEventPage ? 'default' : 'pointer',

		'&:hover': {
			borderColor: isOpeningEventPage ? `${primaryColor}33` : `${primaryColor}CC`,
		},
	},
	loader: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		zIndex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
	},
	avatar: {
		width: { xs: '100%', sm: '160px' },
		height: '100%',

		'&:after': {
			content: '""',
			position: 'absolute',
			right: '-1px',
			top: 0,
			width: '20px',
			height: '100%',
			background: 'linear-gradient(90deg, rgba(16, 16, 16, 0) 0%, rgba(16, 16, 16, 1) 100%)',
		},

		[theme.breakpoints.down('sm')]: {
			'&:after': {
				display: 'none',
			},
		},
	},
	content: {
		position: { xs: 'absolute', sm: 'relative' },
		px: { xs: '12px', sm: '24px' },
		display: 'flex',
		flex: 1,
		flexDirection: { xs: 'column', sm: 'row' },
		overflow: 'hidden',
		justifyContent: { xs: 'flex-end', sm: 'unset' },
		py: { xs: '12px', sm: 0 },
		height: { xs: '100%', height: 'auto' },
		width: { xs: '100%', height: 'auto' },
		background: {
			xs: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 34.75%, rgba(0, 0, 0, 0.8) 91.84%)',
			sm: 'rgba(16,16,16,1)',
		},
	},
	price: {
		position: 'absolute',
		top: '8px',
		right: '8px',
		backgroundColor: '#FFE23F',
		fontFamily: 'Integral CF',
		fontSize: '10px',
		fontWeight: 600,
		lineHeight: '12px',
		p: '2px 6px',
		borderRadius: '2px',
	},
	data: {
		display: 'flex',
		flexDirection: { xs: 'column-reverse', sm: 'column' },
		justifyContent: 'center',
		gap: { xs: '5px', sm: '24px' },
		flex: { xs: 'unset', sm: 1 },
		overflow: 'hidden',
	},
	name: {
		width: '100%',
		fontFamily: 'Montserrat',
		fontSize: { xs: '18px', sm: '16px' },
		fontWeight: 700,
		lineHeight: { xs: '22px', sm: '20px' },
		color: '#FFFFFF',
		maxWidth: '100%',
	},
	item: {
		display: 'flex',
		color: '#F1F1F1',
		gap: '7px',
		alignItems: 'center',
		width: '100%',
		overflow: 'hidden',

		'& >svg': {
			width: '18px',
			height: '18px',
		},
	},
	itemText: {
		flex: 1,
		fontFamily: 'Montserrat',
		fontSize: { xs: '12px', sm: '14px' },
		fontWeight: 600,
		lineHeight: { xs: '14px', sm: '18px' },
	},
	spotsLeftText: {
		color: '#F1F1F1',
		fontFamily: 'Montserrat',
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '14px',
		position: 'absolute',
		left: 0,
		top: '-18px',
		textAlign: 'center',
		width: '100%',
	},
	pastEventLabel: {
		fontFamily: 'Montserrat',
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '15px',
		color: lightTextColor ? `${lightTextColor}B2` : '#FFFFFF',
	},
	joinButton: {
		padding: '12px 32px',
		borderRadius: '100px',
		backgroundColor: 'transparent',
		fontFamily: 'Integral CF',
		fontSize: '13px',
		color: '#FFFFFF',
		fontWeight: 600,
		lineHeight: '19px',
		border: '1px solid #FFF',
		textTransform: 'uppercase',

		'&:hover': {
			backgroundColor: primaryColor,
			borderColor: primaryColor,

			boxShadow: `-17px 8px 24px ${primaryColor}1A,
      	10.01px 13px 24px ${primaryColor}1A,
      	12px 13px 30.6px -11px ${primaryColor}4D`,
		},

		'&:disabled': {
			color: '#FFFFFF',
			pointerEvents: 'none',
			cursor: 'default',
		},
	},
	viewOtherDates: {
		width: 'fit-content',
		padding: '6px 12px',
		borderRadius: '100px',
		fontFamily: 'Integral CF',
		fontSize: '12px',
		color: '#FFFFFF',
		fontWeight: 500,
		lineHeight: '19px',
		border: '1px solid #FFFFFF66',

		'&:hover': {
			color: '#000000',
			backgroundColor: '#FFFFFF',
		},
	},
	avatarGroup: {
		display: 'flex',
		justifyContent: 'center',

		'& .MuiAvatar-root': {
			width: '24px',
			height: '24px',
			border: 0,
		},

		'& >div': {
			marginRight: '-6px',

			'&:last-child': {
				marginRight: 0,
			},
		},
	},
	participantsCount: {
		position: 'relative',
		width: '24px',
		height: '24px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		border: '1px solid #FFFFFF1A',
		background: backgroundColor,
		borderRadius: '50%',

		'& .MuiTypography-root': {
			fontFamily: 'Integral CF',
			fontSize: '9px',
			fontWeight: 500,
			lineHeight: '14px',
			marginTop: '-2px',
			color: '#FFFFFF',
		},
	},
});
